// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-modal-container {
  position: absolute;
  width: 320px;
  top: 50%;
  left: 50%;  
  background: #2C3C44;
  text-align: center;
  border: 1px solid #2C3C44;
  color: #FFFFFF;
  padding: 2rem;
}

.simple-modal-title {
  font-size: var(--subheader);
  font-weight: 500;
  text-align: left;
  margin: 0.5rem 0;
  text-align: center;
}
.simple-modal-description {
  font-size: var(--caption);
  font-weight: normal;
  text-align: center;
}
.simple-modal-btn {
  padding: 0.5rem;
  margin: 0.2rem;
  border: 1px solid #556269;
  color: #FFFFFF;
  width: 150px;
  font-size: var(--caption);
  font-family: "Segoe UI";
  cursor: pointer;
  background: #556269;

}

.simple-modal-btn:hover {
  background: #70818a;
}

.simple-modal-wrapper-btn {
  text-align: right;
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/components/ModalDetail/ModalDetail.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;;AAErB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".simple-modal-container {\n  position: absolute;\n  width: 320px;\n  top: 50%;\n  left: 50%;  \n  background: #2C3C44;\n  text-align: center;\n  border: 1px solid #2C3C44;\n  color: #FFFFFF;\n  padding: 2rem;\n}\n\n.simple-modal-title {\n  font-size: var(--subheader);\n  font-weight: 500;\n  text-align: left;\n  margin: 0.5rem 0;\n  text-align: center;\n}\n.simple-modal-description {\n  font-size: var(--caption);\n  font-weight: normal;\n  text-align: center;\n}\n.simple-modal-btn {\n  padding: 0.5rem;\n  margin: 0.2rem;\n  border: 1px solid #556269;\n  color: #FFFFFF;\n  width: 150px;\n  font-size: var(--caption);\n  font-family: \"Segoe UI\";\n  cursor: pointer;\n  background: #556269;\n\n}\n\n.simple-modal-btn:hover {\n  background: #70818a;\n}\n\n.simple-modal-wrapper-btn {\n  text-align: right;\n  display: contents;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
